import { UtilService } from './utils';
const im = {
    /**
     *登录云通讯
    */
    login(userId, loginChange) {
        (window || window).im.login(String(userId), UtilService.RegisterWinFunc(loginChange));
    },
    /**
     *   注册登录状态变化事件
     */
    registerReceiveEvent(messageReceive) {
        //todo winform确定之后记得更改
        return (parent.window || window).im.registerReceiveEvent(messageReceive);
    },
    /**
     * 发送文本消息
     */
    sendText(text, userId) {
        //todo winform确定之后记得更改
        return (parent.window || window).im.sendText(text, userId);
    },
    /**
     * 群通知
     * @param {Function} callback
    */
    groupNoticeEvent(callback) {
        (window || window).im.registerGroupNoticeEvent(UtilService.RegisterWinFunc(callback));
    },
    /**
     * 发送完成事件
     * @param {Function} callback
     */
    sendEvent(callback) {
        (window || window).im.registerSendMsgResultEvent(UtilService.RegisterWinFunc(callback));
    },
    /**
     * 播放音频完成事件
     * @param {Function} callback
     */
    playVoiceEnd(callback) {
        (window || window).im.registerPlayVoiceFinishedEvent(UtilService.RegisterWinFunc(callback));
    },
    /**
     * 播放音频事件
     * @param
     * isStop传入true 则停止播放
     * key  需要拼接为谁的消息 和那一条消息domain
     */
    playVoice(path, sessionId, domain, isStop = false) {
        (window || window).im.playVoice(path, sessionId, domain, isStop);
    },
    /**
     * 发送消息（暂时不可用）
     * @param {string} message
     * @param {string} receiveId
     * @returns {Promise<string>}
     */
    send(CategoryId, message, receiveId, domain) {
        //改造底座版本   需要改为发送状态监控
        // let saveRecordDataID = receiveId;
        // if (CategoryId === Category.IMGroup) {
        //   saveRecordDataID = saveRecordDataID.replace("gg", "")
        // }
        // DataService.post(`${ApiService.IM}/SaveRecordByClient`, {//消息记录前端抄送 不再走云通信
        //   SessionCategoryID: CategoryId,
        //   RecvDataID: saveRecordDataID,
        //   MsgText: message,
        //   Domain: domain
        // });
        return (window || window).im.sendText(message, receiveId, domain);
    },
    /**
     * 接收消息
     * @param {Function} receiveMessage
     */
    receive(receiveMessage) {
        (window || window).im.registerReceiveEvent(UtilService.RegisterWinFunc(receiveMessage));
    },
    /**
     * 创建群组
     * @param complete ('0/1','{groupId}', '{描述，比如错误描述}')：命令执行完毕后的回调，下同。
     * @param scope 群最大人数 1:100 2:300 3:500 4:1000 5:2000
    */
    createGroup(groupName, scope = 1, complete) {
        let key = UtilService.RegisterWinFunc(complete);
        return (window || window).im.createGroup(groupName, scope, key);
    },
    /**
     * 解散群组
     */
    dismissGroup(groupID, complete) {
        let key = UtilService.RegisterWinFunc(complete);
        return (window || window).im.dismissGroup('gg' + groupID, key);
    },
    /**
     *  主动加人入群（无需验证  ）
     */
    inviteJoinGroup(groupID, userIdArray, complete) {
        let key = UtilService.RegisterWinFunc(complete);
        return (window || window).im.inviteJoinGroup('gg' + groupID, JSON.stringify(userIdArray), key);
    },
    /**
     *  申请入群（需验证  ）
     */
    applyJoinGroup(groupID, declared, complete) {
        let key = UtilService.RegisterWinFunc(complete);
        return (window || window).im.applyJoinGroup('gg' + groupID, declared, key);
    },
    /**
     *  同意入群申请
     *confirm  / 2同意 1拒绝
     */
    replyRequestJoinGroup(groupID, userId, confirm, complete) {
        let key = UtilService.RegisterWinFunc(complete);
        return (window || window).im.replyRequestJoinGroup('gg' + groupID, userId, confirm, key);
    },
    /**
     * 将人剔出群
     */
    deleteGroupMember(groupID, userId, complete) {
        let key = UtilService.RegisterWinFunc(complete);
        return (window || window).im.deleteGroupMember('gg' + groupID, userId + "", key);
    },
    /**
     *   主动退群
     */
    quitGroup(groupID, complete) {
        let key = UtilService.RegisterWinFunc(complete);
        return (window || window).im.quitGroup('gg' + groupID, key);
    },
    /**
     * 设置群成员角色,1群主 2管理员 3成员
     * @param {string} groupKey
     * @param {string} userId
     * @param {number} role
     * @param {Function} complete
     * @returns {boolean}
    */
    setGroupMemberRole(groupID, userId, role = 2, complete) {
        let key = UtilService.RegisterWinFunc(complete);
        return (window || window).im.setGroupMemberRole('gg' + groupID, userId + "", role, key);
    }
};
export default im;
